import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "components/bootstrap";
const hasRiskScore = (riskScore) => riskScore !== null && riskScore !== void 0;
const getRiskScoreStyle = (riskScore) => {
  if (!hasRiskScore(riskScore) || riskScore < 25) return "default";
  if (riskScore < 50) return "info";
  if (riskScore < 75) return "warning";
  return "danger";
};
const RiskScoreBadge = ({ riskScore, size = "sm" }) => {
  const { t } = useTranslation("enterprise_security_app");
  const riskScoreStr = hasRiskScore(riskScore) ? riskScore.toFixed(1) : "N/A";
  return /* @__PURE__ */ React.createElement(
    Badge,
    {
      bsStyle: getRiskScoreStyle(riskScore),
      title: t("risk_score_badge.title", { score: riskScoreStr }),
      bsSize: size
    },
    riskScoreStr
  );
};
export default RiskScoreBadge;
